class ScaleBgMark {
	static before(bg, other) {
		return new ScaleBgMark(bg, other.time - bg._scale.major);
	}

	static after (bg, other) {
		return new ScaleBgMark(bg, other.time + bg._scale.major);
	}

	constructor(bg, time) {
		this._scale = bg._scale;
		this._time = time || bg._scale.start;
		this._mark = UI.div('scaleBgMarker');
		bg._elem.appendChild(this._mark);
	}

	dispose() {
		this._mark.remove();
	}

	get time() {return this._time;}
	set time(v) {this._time = v;}

	findMajor() {
		this._time = Math.floor(this._time / this._scale.major) * this._scale.major;
		if (this._scale.major == 604800000) { // weekly - back up to monday
			let dt = new Date(this._time);
			let dayOffset = (dt.getDay() || 7) - 1;
			if (dayOffset) {
				dt.setDate(dt.getDate() - dayOffset);
				this._time = dt.getTime();
			}
		}
	}

	move() {
		let left = this._scale._timeline.timeToOffset(this._time);
		this._mark.style.left = left + 'px';
	}
}
